import type { ReportBlock } from '@/lib/types/report'

export function UnsupportedBlock({ block }: { block: ReportBlock }) {
  return (
    <div className="rounded-md border border-dashed border-border p-3 text-sm text-muted-foreground">
      unsupported block: {block.type}
    </div>
  )
}
